import { DropdownOptionDTO } from '../interface/app-common.interface';
import {
  GridColumnDTO,
  IssueIdAPIDTO,
  TaxAccountingEditDTO,
} from '../interface/taxAccounting.interface';

export const TAX_ACCOUNTING_LABELS = {
  FILTERS: {
    ISSUE_ID: 'Issue ID',
    TBBS: 'TBBS',
    ISSUE_STATUS: 'Issue Status',
    DATE: 'Date >=',
    ALL_ISSUES: 'All Issues',
    ASC_740_10: 'ASC 740-10',
    SELECT: 'Select',
    DOWNLOAD_EXCEL: `Download Excel`,
  },

  HEADER: {
    ISSUE_NO: 'Issue #',
    ENTITY_CODE: 'Entity Code',
    YEAR: 'Year',
    PRIOR_2018: 'Prior 2018',
    AFTER_2017: 'After 2017',
    US: 'US',
    PASSIVE: 'Passive',
    CAPITAL_GAIN: 'Capital Gain',
    GENERAL: 'General',
    FOGEI: 'FOGEI',
    FORI: 'FORI',
    BR_NOGI: 'Br NOGI',
    BR_CFOGI: 'Br CFOGI',
    NBR_NOGI: 'NBr NOGI',
    NBR_CFOGI: 'NBr CFOGI',
    GILTI_NOGI: 'GILTI NOGI',
    GILTI_FORI: 'GILTI FORI',
  },

  DETAILS: {
    CONTACT: 'Contact:',
    APPROVER: 'Approver:',
    CREATED_ON: 'Created On:',
    MODIFIED_ON: 'Modified On:',
  },

  ISSUE: {
    ISSUE: 'Issue',
    ASC_740_10: 'ASC 740-10',
    TBBS_STATUS: 'TBBS Status',
    TBBS: 'TBBS',
  },

  FOOTER: {
    AR_FILING_ID: 'AR Filing ID',
    AR_ISSUE_ID: 'AR Issue ID',
    IRS_ISSUE_ID: 'IRS Issue ID',
    SAA_NO: 'SAA #',
    SUBMISSION: 'Submission',
    SP_LINK: 'SP Link',
    NPA: 'NPA',
    ISSUE_STATUS: 'Issue Status',
  },

  TOP_HEADERS: [
    {
      label: 'Issue #',
      column: '1 / 7',
      className: 'issue-group',
    },
    {
      label: 'Prior 2018',
      column: '7 / 10',
      className: 'prior-header',
    },
    {
      label: 'After 2017',
      column: '10 / 16',
      className: 'after-header',
    },
  ],

  COLUMN_HEADERS: [
    { label: 'Entity Code', className: 'text-left' },
    { label: 'Year', className: '' },
    { label: '', className: '' },
    { label: 'US', className: '' },
    { label: 'Passive', className: '' },
    { label: 'Capital Gain', className: 'customRightBorder customMR' },
    { label: 'General', className: '' },
    { label: 'FOGEI', className: '' },
    { label: 'FORI', className: 'customRightBorder' },
    { label: 'Br NOGI', className: '' },
    { label: 'Br CFOGI', className: '' },
    { label: 'NBr NOGI', className: '' },
    { label: 'NBr CFOGI', className: '' },
    { label: 'GILTI NOGI', className: '' },
    { label: 'GILTI FORI', className: '' },
  ],
} as const;

export const ISSUE_ID_OPTIONS: DropdownOptionDTO[] = [
  { label: '1-0723', value: '1-0723' },
  { label: '2-0953', value: '2-0953' },
  { label: '3-1050', value: '3-1050' },
];

export const TBBS_OPTIONS: DropdownOptionDTO[] = [
  { label: 'Waiting', value: 'Waiting' },
  { label: 'Completed', value: 'Completed' },
];

export const ISSUE_STATUS_OPTIONS: DropdownOptionDTO[] = [
  { label: 'Active', value: 'Active' },
  { label: 'Closed', value: 'Closed' },
];

export const ISSUE_ID_MOCK_DATA: IssueIdAPIDTO[] = [
  {
    success: true,
    result: [
      '1-0000',
      '1-0001',
      '1-0002',
      '1-0003',
      '1-0004',
      '1-0005',
      '1-0006',
      '1-0007',
      '1-0008',
      '1-0009',
      '1-0010',
    ],
    message: 'Issue Ids fetched successfully.',
  },
];

export const TAX_ACCOUNTING_COLUMNS: GridColumnDTO[] = [
  {
    key: 'issueId',
    label: 'Issue ID',
  },
  {
    key: 'entity',
    label: 'Entity',
  },
  {
    key: 'asc740',
    label: 'ASC 740',
  },
  {
    key: 'checkbox',
    label: '',
  },
  {
    key: 'description',
    label: '',
  },
];
